// importing custom shorthand method from JJ
import { $qs, $qsa } from '../../../src/js/utils/QuerySelector';
// importing gsap
import gsap from 'gsap';

// declaring close function on array variable
function closeAllAccordions(accordions) {
    // looping through each object in array
    [...accordions].forEach((accordion) => {
        // setting content variable as element with specified data target, specific to each array object
        const content = $qs('[data-target="accordion-content"]', accordion);
        // setting iconClose variable as element with specified data target, specific to each array object
        const iconClose = $qs('[data-target="icon-close"]', accordion);
        // setting iconOpen variable as element with specified data target, specific to each array object
        const iconOpen = $qs('[data-target="icon-open"]', accordion);

        // add 'colsed' state to dataset of both each and every array object
        accordion.dataset.state = 'closed';
        // set gsap animation duration and position to variable content
        gsap.to(content, { height: 0, duration: 0.5 });

        // Show the open icon
        gsap.to(iconClose, { rotation:90 });
    });
}

// declaring accordion function
function accordion() {
    // getting all 'accordion' elements and putting them into an array so that if there are more than 1 on a page it still works
    const accordions = $qsa('[data-target="accordion"]');

    // do nothing if no accordions exist
    if (!accordions) return;

    // for each accordion on the page
    [...accordions].forEach((accordion) => {
        // setting trigger variable as element with specified data target, specific to each accordion
        const trigger = $qs('[data-target="accordion-trigger"]', accordion);
        // setting content variable as element with specified data target, specific to each accordion
        const content = $qs('[data-target="accordion-content"]', accordion);
        // setting iconClose variable as element with specified data target, specific to each array object
        const iconClose = $qs('[data-target="icon-close"]', accordion);
        // setting iconOpen variable as element with specified data target, specific to each array object
        const iconOpen = $qs('[data-target="icon-open"]', accordion);

        // setting iconClose variable as element with specified data target, specific to each array object
        const iconCloseSVG = $qs('[data-target="icon-close-svg"]', accordion);
        // setting iconOpen variable as element with specified data target, specific to each array object
        const iconOpenSVG = $qs('[data-target="icon-open-svg"]', accordion);

        // Show the open icon
        gsap.set(iconClose, { rotation:90 });

        // when trigger is clicked
        trigger.addEventListener('click', () => {
            // declare anonymous variable and assign it to the dataset of the current accordion
            const { state } = accordion.dataset;

            // use previous function to close all other accordions
            closeAllAccordions(accordions);

            // if state of current trigger is 'closed'
            if (state === 'closed') {
                // update the state variable of the dataset of the current accordion to be 'open'
                accordion.dataset.state = 'open';
                // set gsap animation duration and position to variable content
                gsap.to(content, { height: 'auto', duration: 0.5 });
                // Hide the close icon
                // iconClose.style.display = 'none';
                // Show the open icon
                // iconOpen.style.display = 'block';

   
                // Show the open icon
                gsap.to(iconClose, { rotation:0 });
            } else {
                // update the state variable of the dataset of the current accordion to be 'open'
                accordion.dataset.state = 'closed';
                // set gsap animation duration and position to variable content
                gsap.to(content, { height: 0, duration: 0.5 });
                // Hide the open icon
                // iconOpen.style.display = 'none';
                // Show the close icon
                // iconClose.style.display = 'block';


                // Show the close icon
                gsap.to(iconClose, { rotation:90 });
            }
        });
    });
}

export default accordion;